<script> 
import apigeneric from "@/helpers/apigeneric";
export default { 
  mixins: [ apigeneric],
  data() {
    return { 
        NoticesData:{},
        NoticesTitle: {},
        ActiveNotices: [],
        showNoticesModal: false,
        NoticesTitleDescription: {},
        ReadMoreValue: {},
        DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: { 
   
  }, 
  methods: { 
    getLang() {
      return localStorage.getItem("lang") || "tr";
    },
    getFirstImage(gallery) {
      if (gallery && typeof gallery === 'string' && gallery.trim() !== '') {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    handleImgError(e) {
      e.target.style.display = 'none';
      if (e.target.parentElement) {
        const fallback = e.target.parentElement.querySelector('.img-fallback-icon');
        if (fallback) fallback.style.display = 'flex';
      }
    },
    Get(){
        let Page = {
      PageNumber: "1",
      PageSize: "8",
      PageDataSize: "1", 
    };
        this.ActionsFilterGet({
        Service: "News",
        Page: Page,
        Filter:"&Desc=Startdate&Newstype=1&Websiteid="+window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NoticesData = res.Data; 

        console.log(JSON.stringify( this.NoticesData))

          this.ActiveNotices = this.NoticesData.filter(x => x.Islightbox);

        if (this.ActiveNotices.length > 0) {
          this.showNoticesModal = true;
        }

      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.localStorage.getItem("lang")
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=215b4e3e-250f-4ebd-bf96-f04aec90de20"
          }).then((res) => {
            this.NoticesTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });


      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.localStorage.getItem("lang")
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=19269e1f-b2fe-4ea9-9a2b-4c5cd91d2266"
          }).then((res) => {
            this.NoticesTitleDescription = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

     

    }
  },
};
</script>

<template> 
       
    <section>
        <div class="notices">
            <div class="title c-flex flex-column">
                <a :href="'/fullnotices/tr'" class="card-link"><h3>{{$t("dashboards.NoticesTitle")}}</h3></a>
                <p>{{$t("dashboards.NoticesDescription")}}</p>
            </div> 
            <div class="container">
                <div class="row align-items-stretch">
              
                        <div class="col-md-6 mb-4 d-flex align-items-stretch" v-for="Data in NoticesData" :key="Data.Id">
                          <div class="notice-item w-100 h-100 d-flex flex-column">
                            <div class="row h-100 g-0">
                                <div class="col-md-5 d-flex align-items-stretch">
                                    <div class="notice-img-box w-100 h-100">
                                        <img v-if="getFirstImage(Data.Imagegallery)" :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)" alt="" @error="handleImgError" />
                                        <div class="img-fallback-icon h-100" :style="{ display: getFirstImage(Data.Imagegallery) ? 'none' : 'flex' }">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#ffffff" opacity="0.85" viewBox="0 0 16 16">
                                                <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 13V2.5zM1.5 2a.5.5 0 0 0-.5.5v10.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2.5a.5.5 0 0 0-.5-.5h-11z"/>
                                                <path d="M3 4h8v1H3V4zm0 3h8v1H3V7zm0 3h5v1H3v-1z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7 d-flex justify-content-between flex-column h-100">
                                    <div>
                                        <p class="head">{{Data.Title}}</p>
                                        <p class="date">{{Data.Startdate | formatDateTime }}</p>
                                        <p class="content">
                                             <span v-html="Data.Description"></span><br />
                                        </p>
                                    </div>
                                    <a :href="'/NewsDetail/tr/'+ Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/' + Data.Id" class="read-more mt-auto">{{$t("OrtakKullanim.ReadMore")}} &#8594;</a>
                                </div>
                            </div>
                          </div>
                    </div>               
                </div>
                <div class="d-flex justify-content-center mt-3">
                    <a :href="'/fullnotices/' + getLang()" class="btn-more-show">
                        Daha Fazla Göster &rarr;
                    </a>
                </div>
            </div>
        </div>

      <b-modal
        v-model="showNoticesModal"
        size="xl"
        centered
        title="Aktif Duyurular"
        hide-footer
      >
        <div v-for="item in ActiveNotices" :key="item.Id" class="mb-4 border-bottom pb-3">
          <h5>{{ item.Title }}</h5>
          <br>
          <p class="text-muted">
            {{ item.Startdate | formatDateTime }}
          </p>

          <div class="notice-modal-img-box mb-2" v-if="item.Imagegallery">
            <img
              v-if="getFirstImage(item.Imagegallery)"
              :src="$config.FILES_URL + 'web/' + getFirstImage(item.Imagegallery)"
              class="img-fluid notice-modal-img"
              @error="handleImgError"
            />
            <div class="img-fallback-icon" :style="{ display: getFirstImage(item.Imagegallery) ? 'none' : 'flex' }">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#ffffff" opacity="0.85" viewBox="0 0 16 16">
                  <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 13V2.5zM1.5 2a.5.5 0 0 0-.5.5v10.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2.5a.5.5 0 0 0-.5-.5h-11z"/>
                  <path d="M3 4h8v1H3V4zm0 3h8v1H3V7zm0 3h5v1H3v-1z"/>
              </svg>
            </div>
          </div>

          <div v-html="item.Description"></div>

          <div class="text-end mt-2">
            <a
              :href="'/NewsDetail/tr/' + item.Title.toLowerCase()
                .replace(/I|İ/gi, 'i')
                .replace(/Ğ|ğ/gi, 'g')
                .replace(/Ç|ç/gi, 'c')
                .replace(/\s+/g, '-')
                .replace(/&/g, '-and-')
                .replace(/--/g, '-') + '/' + item.Id"
              class="btn btn-sm btn-outline-primary"
            >
              Devamını Oku →
            </a>
          </div>
        </div>
      </b-modal>


    </section>

</template>

<style scoped>
.notice-item {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.notice-img-box {
  width: 100%;
  height: 100%;
  min-height: 180px;
  background-color: #00758f;
  border-radius: 40px 40px 0 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .notice-img-box {
    border-radius: 40px 0 0 40px;
  }
}
.notice-img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #00758f;
}
.notice-modal-img-box {
  width: 100%;
  max-height: 400px;
  background-color: #00758f;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notice-modal-img {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
  background-color: #00758f;
}
.img-fallback-icon {
  width: 100%;
  height: 100%;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00758f;
}
.btn-more-show {
  display: inline-block;
  background-color: #00758f;
  color: #ffffff !important;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 30px;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 117, 143, 0.2);
}
.btn-more-show:hover {
  background-color: #005a6e;
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 117, 143, 0.35);
}
</style>
